import React from 'react';
import { Gamepad2 } from 'lucide-react';
import { GameSummary } from '@/api/types';
import { MobileGameCard } from './mobile-game-card';
import styles from './mobile-game-grid.module.css';

interface MobileGameGridProps {
  games: GameSummary[];
  title?: string;
  showRank?: boolean;
  emptyText?: string;
}

export const MobileGameGrid: React.FC<MobileGameGridProps> = ({
  games,
  title = '全部游戏',
  showRank = false,
  emptyText = '暂无游戏',
}) => {
  if (games.length === 0) {
    return (
      <section className={styles.section}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            <Gamepad2 className={styles.icon} size={18} />
            {title}
          </h2>
        </div>
        <div className={styles.empty}>
          <div className={styles.emptyIcon}>📭</div>
          <p className={styles.emptyText}>{emptyText}</p>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          <Gamepad2 className={styles.icon} size={18} />
          {title}
        </h2>
        <span className={styles.count}>共 {games.length} 款</span>
      </div>
      <div className={styles.list}>
        {games.map((game, index) => (
          <MobileGameCard 
            key={game.id} 
            game={game} 
            index={showRank ? index : undefined}
          />
        ))}
      </div>
    </section>
  );
};

export default MobileGameGrid;
